import Build from '@mui/icons-material/Build'
import DirectionsBus from '@mui/icons-material/DirectionsBus'
import GolfCourse from '@mui/icons-material/GolfCourse'
import Pets from '@mui/icons-material/Pets'
import { IAgeRestrictionType, ISellerTypeID } from 'mhbo-js'
import React from 'react'
import DoorOpen from '../../../../assets/door-open.svg'
import HomeCurrencyUSD from '../../../../assets/home-currency-usd.svg'
import HomeGroup2 from '../../../../assets/home-group-2.svg'
import HomeModern from '../../../../assets/home-modern.svg'
import HumanFemaleBoy from '../../../../assets/human-female-boy.svg'

interface IProps {
  isCommunity?: boolean
  isFeatured?: boolean
  ageRestrictionType?: IAgeRestrictionType | null
  askingPrice?: number
  withPetFriendly?: boolean
  isResidentOwned?: boolean
  isMhrv?: boolean
  sellerTypeId?: ISellerTypeID | null
  rentalPrice?: number | null
}

const Flags: React.FC<IProps> = (props: IProps) => {
  const {
    isCommunity = false,
    isFeatured = false,
    ageRestrictionType = null,
    askingPrice = null,
    withPetFriendly = false,
    isResidentOwned = false,
    isMhrv = false,
    sellerTypeId = null,
    rentalPrice = null,
  } = props
  return (
    <div>
      {isFeatured ? (
        <div className="listingCell__chip_home">featured</div>
      ) : null}
      {isCommunity ? (
        <div className="listingCell__chip_community">community</div>
      ) : null}
      {withPetFriendly ? (
        <div className="listingCell__chip_flags">
          <Pets /> <span>pet friendly</span>
        </div>
      ) : null}
      {ageRestrictionType === IAgeRestrictionType.AllAges ? (
        <div className="listingCell__chip_flags">
          <img src={HumanFemaleBoy} alt="" /> <span>All Ages</span>
        </div>
      ) : null}
      {sellerTypeId === ISellerTypeID.Owner ? (
        <div className="listingCell__chip_flags">
          <img src={HomeCurrencyUSD} alt="" /> <span>for sale by owner</span>
        </div>
      ) : null}
      {isResidentOwned ? (
        <div className="listingCell__chip_flags">
          <img src={HomeGroup2} alt="" /> <span>resident owned community</span>
        </div>
      ) : null}
      {isMhrv ? (
        <div className="listingCell__chip_flags">
          <DirectionsBus /> <span>rv resort</span>
        </div>
      ) : null}
      {sellerTypeId === ISellerTypeID.Repo ? (
        <div className="listingCell__chip_flags">
          <img src={DoorOpen} alt="" /> <span>repo</span>
        </div>
      ) : null}
      {sellerTypeId === ISellerTypeID.Dealer ? (
        <div className="listingCell__chip_flags">
          <img src={HomeModern} alt="" /> <span>new home</span>
        </div>
      ) : null}
      {ageRestrictionType === IAgeRestrictionType.FiftyFivePlus ? (
        <div className="listingCell__chip_flags">
          <GolfCourse /> <span>55+</span>
        </div>
      ) : null}
      {rentalPrice ? (
        <div className="listingCell__chip_rent">FOR RENT</div>
      ) : null}
      {askingPrice ? (
        <div className="listingCell__chip_sale">FOR SALE</div>
      ) : null}
    </div>
  )
}
export default Flags
